/* unplugin-vue-components disabled */import { render } from "./DeviceNumber.vue?vue&type=template&id=af734546&scoped=true"
import script from "./DeviceNumber.vue?vue&type=script&lang=js"
export * from "./DeviceNumber.vue?vue&type=script&lang=js"

import "./DeviceNumber.vue?vue&type=style&index=0&id=af734546&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af734546"]])

export default __exports__